import { noop } from 'lodash';
import { useMount } from 'react-use';

import { DoctorSimple } from '@dreryk/egabinet-personnel-frontend-api';
import { ReceptionServiceWithPractitionersSimple } from '@dreryk/egabinet-private-medical-service-frontend-api';

import { PrescriptionVisitFormController } from './PrescriptionVisitForm.types';
import { resolveReceptionServiceFromTemplate } from './PrescriptionVisitForm.utils';

type UseAutoResolveReceptionServiceOptions = Pick<PrescriptionVisitFormController, 'watch' | 'setValue'> & {
   enabled: boolean;
   practitioners: DoctorSimple[];
   receptionServices: ReceptionServiceWithPractitionersSimple[];
};

export const useAutoResolveReceptionServiceFromTemplate = (options: UseAutoResolveReceptionServiceOptions): void => {
   useMount(() => {
      const { practitioner: initialPractitioner, receptionService: initialReceptionService } = options.watch([
         'practitioner',
         'receptionService',
      ]);

      if (!options.enabled || options.practitioners.length !== 1 || !initialPractitioner || initialReceptionService) {
         return;
      }

      resolveReceptionServiceFromTemplate(initialPractitioner.practitionerId, options.receptionServices)
         .then((service) => options.setValue('receptionService', service))
         .catch(noop);
   });
};
